const getErrorMessage = async (response: Response) => {
  let message = null;
  if (response.status === 401) {
    return "You are not logged in";
  }
  try {
    const data = await response.json();
    message = data.message;
  } finally {
    return message || "Something went wrong";
  }
};

export default getErrorMessage;
